import axios from 'axios'
console.log('desde config axios', process.env.VUE_APP_API)
axios.defaults.baseURL = process.env.VUE_APP_API
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.interceptors.request.use(config => {
  const publicRoutes = ['/api/login', '/api/validarOtp', '/api/validarToken']
  if (publicRoutes.includes(config.url || '')) {
    delete config.headers.Authorization
    return config
  }

  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})
export default axios
